<template>
	<article class="image__slider">
		<div class="image__slider__left">
			<button aria-label="slide-left" type="button" @click="slide('left')">
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
					<path
						d="M12.707 17.293 8.414 13H18v-2H8.414l4.293-4.293-1.414-1.414L4.586 12l6.707 6.707z"></path>
				</svg>
			</button>
		</div>

		<ol class="image__slider__wrapper">
			<li class="image-container" v-for="url in imagesUrl">
				<img :src="url" alt="#">
			</li>
		</ol>

		<div class="image__slider__right">
			<button aria-label="slide-right" type="button" @click="slide('right')">
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
					<path
						d="m11.293 17.293 1.414 1.414L19.414 12l-6.707-6.707-1.414 1.414L15.586 11H6v2h9.586z"></path>
				</svg>
			</button>
		</div>
	</article>
</template>

<script>

export default {
	name: "ImageSlider",
	props: {
		imagesUrl: {
			required: true,
		},
	},
	methods: {
		slide: function(direction) {
			const productsWidth = this.$el.querySelector('.image__slider__wrapper .image-container img').getBoundingClientRect().width
			const slider = this.$el.querySelector('.image__slider__wrapper')
			const leftButton = this.$el.querySelector('.image__slider__left button')
			const rightButton = this.$el.querySelector('.image__slider__right button')

			if (direction === 'left') {
				slider.scrollLeft -= productsWidth
			} else if (direction === 'right') {
				slider.scrollLeft += productsWidth
			}

			slider.addEventListener('scroll', () => {
				if (slider.scrollLeft <= 10) {
					leftButton.style.opacity = '0'
					leftButton.style.pointerEvents = 'none'
				} else {
					leftButton.style.opacity = '1'
					leftButton.style.pointerEvents = 'all'
				}

				if (slider.scrollLeft + slider.offsetWidth + 10 >= slider.scrollWidth) {
					rightButton.style.opacity = '0'
					rightButton.style.pointerEvents = 'none'
				} else {
					rightButton.style.opacity = '1'
					rightButton.style.pointerEvents = 'all'
				}
			})
		},
	}
}
</script>

<style lang="scss" scoped>
.image__slider {
	@include flex(space-between, center);
	margin: 25px auto;
	position: relative;
	@media screen and (min-width: 992px) {
		gap: 5vw
	}

	&__left, &__right {
		display: none;

		@media screen and (min-width: 992px) {
			display: block
		}

		button {
			@include flex(center, center);
			appearance: none;
			border: solid 1px $Brown;
			background-color: $t;
			width: 50px;
			height: 50px;
			border-radius: 50px;
			transition: .2s;

			&:hover {
				background-color: $Brown;

				path {
					fill: $White;
				}
			}

			svg {
				@include fixed-size(30px);

				path {
					fill: $Brown;
				}
			}
		}
	}

	&__left button {
		opacity: 0;
		pointer-events: none;
	}

	&__wrapper {
		@include flex(flex-start, center, $gap: 15px);
		width: clamp(320px, 100%, 992px);
		max-width: 90vw;
		overflow-x: auto;
		scroll-behavior: smooth;
		scroll-snap-type: x mandatory;
		scroll-snap-align: center;
		scroll-snap-stop: always;
		@media screen and (min-width: 992px) {
			gap: 50px
		}

		&::-webkit-scrollbar {
			height: 0;
		}

		@include is-firefox() {
			scrollbar-width: thin;
			scrollbar-color: $t $t;
		}
		.image-container {
			@include flex(center, center);
			flex: 1;
			width: 100%;
			min-width: 80%;
			position: relative;
			scroll-snap-align: center;
			@media screen and (min-width: 992px) {
				width: 100%;
				min-width: 100%;
			}

			img {
				width: 100%;
				height: 100%;
				object-fit: contain;
			}
		}
	}
}
</style>